import { dashToCamel } from '../../utilities/convertCase';

export class Base {
  constructor(behaviorName, element) {
    this.behaviorName = behaviorName;
    this.element = element;
    this.refs = {};
    this.baseInit();
  }

  baseInit() {
    this.populateRefsObject();
  }

  populateRefsObject() {
    const attribute = `data-ref-${this.behaviorName}`;

    this.element.querySelectorAll(`[${attribute}]`).forEach((refElement) => {
      const attributeValue = dashToCamel(refElement.getAttribute(attribute));
      this.refs[attributeValue] = refElement;
    });
  }

  cleanup() {
    // Override this function in your classes as required
  }
}